import { Button, TextField } from '@mui/material';
import { updateProfile } from 'api/auth';
import RedirectProvider from 'components/RedirectProvider';
import { AuthContext, SnackBarContext } from 'constants/contexts';
import useSentryUpdateEffect from 'hooks/useSentryUpdateEffect';
import React, { useContext, useState } from 'react';
import { captureException, getHttpErrorMessage } from 'utils/error';
import { validateEmail } from 'utils/string';
import AuthWrapper from './AuthWrapper';

function SignUp() {
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useContext(AuthContext);
  const showSnackBar = useContext(SnackBarContext);
  const { redirect } = RedirectProvider.useRedirect();

  useSentryUpdateEffect({
    page: 'signup',
    name,
    email,
  }, [name, email]);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    updateProfile({ name, email })
      .then((res) => {
        setUser({
          customer: res.message?.uuid,
          phone: user.message?.phone,
          email: res.message?.email,
          name: res.message?.name,
        });
        setLoading(false);
        redirect();
      })
      .catch((err) => {
        captureException(err);
        setLoading(false);
        showSnackBar({ message: getHttpErrorMessage(err), type: 'error' });
      });
  };

  return (
    <AuthWrapper
      subTitle="Sign up by entering your details below"
      action={(
        <Button
          size="large"
          fullWidth
          variant="muted"
          onClick={onSubmit}
          disabled={!name || !email || name?.trim()?.length < 3 || !validateEmail(email) || loading}
        >
          Get started
        </Button>
      )}
    >

      <TextField
        error={name?.trim()?.length < 3}
        inputProps={{ minLength: 3 }}
        helperText={
          name?.trim()?.length < 3
            ? 'You should at least enter 3 characters as your name'
            : undefined
        }
        required
        placeholder="Please enter your name"
        label="Name"
        fullWidth
        value={name || ''}
        onChange={(e) => setName(e?.target?.value)}
        InputLabelProps={{ shrink: true }}
        disabled={loading}
      />
      <TextField
        error={email && !validateEmail(email)}
        helperText={
          email
            ? validateEmail(email)
            ? undefined
            : 'Please enter a valid email address'
            : undefined
        }
        type="email"
        required
        fullWidth
        placeholder="Please enter your email"
        label="Email"
        value={email || ''}
        onChange={(e) => setEmail(e?.target?.value)}
        autoComplete="email"
        InputLabelProps={{ shrink: true }}
        disabled={loading}
      />
    </AuthWrapper>
  );
}

export default SignUp;
